import { Base } from '@studiometa/js-toolkit';

/**
 * VariantRadios component with Fetch integration
 * Uses @studiometa/ui Fetch component for automatic DOM updates
 */
export default class VariantRadios extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'VariantRadios',
    emits: ['variant-changed'],
    refs: ['input[]', 'fetchLink'],
    options: {
      url: {
        type: String,
        required: true,
        default: '',
      },
      section: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * Mounted hook
   */
  mounted() {
    this._variantData = JSON.parse(this.$el.querySelector('[type="application/json"]').textContent);
  }

  /**
   * Get options
   * @returns {Array}
   */
  get options() {
    return Array.from(this.$refs.input)
      .filter((input) => input.checked)
      .map((input) => input.value);
  }

  /**
   * Get the current variant
   * @returns {object|null}
   */
  get currentVariant() {
    return this.variantData.find((variant) => {
      return variant.options.every((option, index) => option === this.options[index]);
    });
  }

  /**
   * Get variant Data
   * @returns {Array}
   */
  get variantData() {
    return this._variantData;
  }

  /**
   * Handle input change - trigger fetch via hidden link
   */
  onInputChange() {
    if (!this.currentVariant) {
      return;
    }

    const url = `${this.$options.url}?variant=${this.currentVariant.id}`;

    this.$refs.fetchLink.href = url;
    this.$refs.fetchLink.click();

    this.$emit('variant-changed', { variant: this.currentVariant }, { bubbles: true });
  }
}
